<template>
  <b-button
    variant="primary"
    :disabled="isLoading"
    @click="downloadFile"
  >
    <b-spinner
      v-if="isLoading"
      label="Spinning"
      small
    />
    <feather-icon
      v-else
      icon="LFilterIcon"
    />
    {{ $t('Excel') }}
  </b-button>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import downloadQueueMixin from '@/libs/download-queue-mixin'

export default {
  name: 'DownloadFile',
  components: {
    BSpinner,
    BButton,
  },
  mixins: [downloadQueueMixin],
}
</script>
